// extracted by mini-css-extract-plugin
export default {"PortfolioBlock":"PortfolioBlock_PortfolioBlock__kZzs8","title":"PortfolioBlock_title__J-M8I","blocks":"PortfolioBlock_blocks__OLPyj"};